import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Planning');

export const COUNTRY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Country.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Country.Code')
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const COUNTRY_CONFIG = {
  entityName: 'Country',
  localizationKey: 'Planning::Entity.Country',
  fields: COUNTRY_FIELDS,
  permission: 'PlanningGeography.Countries',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
